import {FC, useState, useEffect, Fragment} from 'react'

type Props = {
  value: any
}

const NumberCircleContent: FC<Props> = ({value}) => {
  return (
    <div className='d-flex justify-content-center align-items-center'>
      <div
        className='rounded-circle bg-light d-flex justify-content-center align-items-center fw-bold text-dark'
        style={{width: '30px', height: '30px'}}
      >
        {value}
      </div>
    </div>
  )
}

const NumberCircle: FC<Props> = ({value}) => {
  return <NumberCircleContent value={value} />
}

export default NumberCircle
